import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class NavigationService {

    currentStepIndex = 0;

    private steps = [
        'inregistrare-programare',
        'inregistrare-programare/detalii-programare',
        'inregistrare-programare/finalizare-programare',
    ];

    constructor(private router: Router) { }

    goNext() {
        if (this.currentStepIndex < this.steps.length - 1) {
            this.currentStepIndex++;
            this.router.navigate([this.steps[this.currentStepIndex]]);
        }
    }

    goBack() {
        if (this.currentStepIndex > 0) {
            this.currentStepIndex--;
            this.router.navigate([this.steps[this.currentStepIndex]]);
        }
    }

    goToStep(index: number) {
        if (index >= 0 && index < this.steps.length) {
            this.currentStepIndex = index;
            this.router.navigate([this.steps[this.currentStepIndex]]);
        }
    }

    isFirstStep(): boolean {
        return this.currentStepIndex === 0;
    }

    isLastStep(): boolean {
        return this.currentStepIndex === this.steps.length - 1;
    }
}
